import Reference from "../../common/Reference";
import type { Field, EarthlySectionComponentProps } from "../../types";
import projectInformation from "../references/project-information.png";
import Section from "../../common/Section/Section";
import { countHtmlTextWords } from "../../../../form/utils";
import { buildProjectInformationField } from "../../../fields/narrative";
import SDGBlock from "../../common/SDGBlock/SDGBlock";

function ProjectInformation({ details, onEdit }: EarthlySectionComponentProps) {
  const { SDG, narrative } = details;
  const shouldShowBeneath = narrative?.projectInformation
    ? countHtmlTextWords(narrative?.projectInformation) > 20
    : false;
  const place = shouldShowBeneath ? "beneath" : "right";
  const fields: Array<Field> = [
    {
      name: "SDGs",
      type: "sdg",
      index: 1,
      fullLine: true,
      value: SDG ?? [],
    },
    buildProjectInformationField(narrative, 0),
  ];

  return (
    <Section
      title="Project information"
      columns={1}
      fields={fields}
      onEdit={() => onEdit("project-information")}
      reference={[
        {
          type: "image",
          place: place,
          index: 0,
          item: (
            <Reference
              image={projectInformation}
              radius="25px"
              alt="Project information reference"
              testId="project-information-reference"
            />
          ),
        },
        {
          type: "component",
          place: place,
          index: 1,
          item: <SDGBlock sdgs={SDG} />,
        },
      ]}
    />
  );
}

export default ProjectInformation;
